<template>
    <div class="overlay popup-overlay" :class="{active: this.$root.popup_active}">
        <div class="close-btn toggle-popup-scroll" @click="this.$root.toggle_popup">
            <span></span>
        </div>
        <div class="container">
            <div class="row" style="min-height: 700px;">
                <div class="col-12 col-lg-6">
                    <h2>{{ localStrings['We are both players.'] }}<br>{{ localStrings['Let’s team up.'] }}</h2>
                    <p>{{ localStrings['Enetpulse remains the most trusted source of live sports scores, facts, and statistics. Our live score feeds from 80+ sports keeps the sporting world alert 24/7.'] }}</p>
                </div>
                <div class="col-12 col-lg-5 offset-lg-1">

                    <div class="row header-form" v-html="contact_form"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            contact_form: {
                type: String,
                default: ''
            },
            background_img_url: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                localStrings: pll_strings // pll strings is defined in template-functions.php
            }
        },
        methods: {

        },
        mounted() {
            // console.log(this.contact_form);
        }
    }
</script>

<style lang="scss" scoped>
    .overlay {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 90%;
        height: 90%;
        overflow: scroll;
        background: $white;
        z-index: 10000;
        opacity: 0;
        visibility: hidden;
        transition: opacity .5s ease, visibility 0s .5s ease;
        display: flex;
        flex-flow: wrap row;
        align-items: center;
        padding: 4rem;
        border-radius: 40px;
        background-repeat: no-repeat;
        background-position: top center;
        background-size: cover;
        // background-size: 60%;
        // background-repeat: no-repeat;
        // background-position: -10% 130%;

        &::-webkit-scrollbar {
            display: none;
        }
        -ms-overflow-style: none;  /* IE and Edge */
        scrollbar-width: none;  /* Firefox */

        .curve-top-element {
            position: absolute;
            top: 0;
            left: 50%;
            z-index: -1;
            transform: translateX(-50%);
            height: 50%;

            .bg {
                height: 50%;
            }

            .curve-bottom {
                height: 100%;
            }
        }

        .background-img {
            position: absolute;
            bottom: -30%;
            left: -10%;
            z-index: -1;
        }

        .close-btn {
            position: absolute;
            top: 1.5rem;
            right: 1.5rem;
            background: transparent;
            width: 30px;
            height: 30px;
            border-radius: 100px;
            border: 1px solid $red;
            cursor: pointer;
            transition: $ts;

           span {
                &:before {
                    content: '';
                    height: 1px;
                    width: 14px;
                    position: absolute;
                    top: 14px;
                    left: 7px;
                    display: block;
                    background: $red;
                    transform: rotate(45deg);
                    transition: $ts;
                }

                &:after {
                    content: '';
                    height: 1px;
                    width: 14px;
                    top: 14px;
                    left: 7px;
                    position: absolute;
                    display: block;
                    background: $red;
                    transform: rotate(-45deg);
                    transition: $ts;
                }
            }

            &:hover {
                background: $red;

                span {
                    &:before {
                        background: $white;
                    }
                    &:after {
                        background: $white;
                    }
                }
            }
        }

        &.active {
            opacity: 1;
            visibility: visible;
            transition: opacity .5s ease;
        }
    }
</style>
